import React from 'react';
import { Text, Box } from '@wix/design-system';
export const Disclaimer = ({ statement }) => {
    return (React.createElement(Box, { display: "block" },
        React.createElement(Text, { weight: "thin", size: "tiny", secondary: true, dataHook: "disclaimer-text" }, statement)));
};
//# sourceMappingURL=Disclaimer.js.map